export interface RootState {
  version: string;
  is_registerd_auth_navigation: boolean; //権限ナビゲーション登録フラグ
}

export const SET_IS_REGISTERD_AUTH_NAVIGATION =
  "SET_IS_REGISTERD_AUTH_NAVIGATION";
